import {
  DEMO_CLAIM_DASHBOARD_PATH,
  DEMO_CLAIM_GO_TO_DASHBOARD_LABEL,
  DEMO_CLAIM_SIGN_IN_DIFFERENT_ACCOUNT_LABEL,
  DEMO_CLAIM_UNAVAILABLE_TITLE,
  DEMO_ORGANIZATION_SIGN_OUT_PATH,
} from "@/constants/demo-organization";
import NextLink from "next/link";

export type DemoClaimErrorProps = {
  message: string;
  signOutCallbackUrl?: string;
};

export const DemoClaimError = ({ message, signOutCallbackUrl }: DemoClaimErrorProps) => {
  const logoutHref = signOutCallbackUrl
    ? `${DEMO_ORGANIZATION_SIGN_OUT_PATH}?callbackUrl=${encodeURIComponent(signOutCallbackUrl)}`
    : null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-6 dark:bg-zinc-950">
      <div className="w-full max-w-md rounded-xl border border-zinc-200 bg-white p-6 shadow-sm dark:border-zinc-700 dark:bg-zinc-900">
        <h1 className="text-heading-3 text-foreground">{DEMO_CLAIM_UNAVAILABLE_TITLE}</h1>
        <p className="mt-3 text-paragraph-small-normal text-muted-foreground">{message}</p>
        <div className="mt-6 flex flex-col gap-3">
          {logoutHref ? (
            <NextLink
              href={logoutHref}
              className="inline-flex text-sm font-medium text-zinc-900 underline underline-offset-2 dark:text-white"
            >
              {DEMO_CLAIM_SIGN_IN_DIFFERENT_ACCOUNT_LABEL}
            </NextLink>
          ) : null}
          <NextLink
            href={DEMO_CLAIM_DASHBOARD_PATH}
            className="inline-flex text-sm font-medium text-zinc-600 underline underline-offset-2 dark:text-zinc-400"
          >
            {DEMO_CLAIM_GO_TO_DASHBOARD_LABEL}
          </NextLink>
        </div>
      </div>
    </div>
  );
};
